export enum EmailProcessSourceEnum {
  PDF = 'PDF',
  EMAIL_BODY = 'Email Body'
}